module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_primærlogo_sentrert_logo_neg.033e1903.pdf";